/**
 * The v1 wave arena as a level (DESIGN 4.2): 40 x 30 units, walls at the
 * boundary, four pillars, the pond, four spawn gates, the player ring at the
 * centre and three training dummies. The floor is the art library's baked
 * plate (games-media `bench plate spellweave`), which is painted from these
 * same numbers.
 */

import type { LevelDef } from './level.js';
import { PLAYER_SPAWN_RING } from './constants.js';

export const ARENA_LEVEL: LevelDef = {
  format: 1,
  id: 'arena',
  name: 'The Arena',
  w: 40,
  h: 30,
  solids: [
    { shape: { k: 'circle', x: 12, y: 9, r: 0.8 }, art: 'pillar' },
    { shape: { k: 'circle', x: 28, y: 9, r: 0.8 }, art: 'pillar' },
    { shape: { k: 'circle', x: 12, y: 21, r: 0.8 }, art: 'pillar' },
    { shape: { k: 'circle', x: 28, y: 21, r: 0.8 }, art: 'pillar' },
  ],
  water: [{ shape: { k: 'ellipse', x: 9, y: 15, rx: 3.5, ry: 2.2 } }],
  rooms: [{ id: 'arena', rect: { x: 0, y: 0, w: 40, h: 30 } }],
  doors: [],
  spawn: { x: 20, y: 15, ring: PLAYER_SPAWN_RING },
  gates: [
    { x: 20, y: 0.5 },
    { x: 20, y: 29.5 },
    { x: 0.5, y: 15 },
    { x: 39.5, y: 15 },
  ],
  dummies: [
    { x: 26, y: 15 },
    { x: 28, y: 13 },
    { x: 28, y: 17 },
  ],
  art: { plate: 'arena' },
};
